import * as Yup from 'yup';

// original single pattern
// const SCDFPlanNoPattern = /^(([A-Z]{3})\/([A-Z]{1})([0-9]{5})\/([0-9]{2})([\S]{1,2})?(,)?)+$/
// commma-delimited pattern
const SCDFPlanNoPattern = /^(([A-Z]{3})\/([A-Z]{1})([0-9]{5})\/([0-9]{2})([0-9A-Z]{1,2})?)(?:,([A-Z]{3})\/([A-Z]{1})([0-9]{5})\/([0-9]{2})([\S]{1,2})?)*$/;


export const SCDFPlanNoSchema = Yup.string().trim().label('SCDF Building Plan No')
.matches(
  SCDFPlanNoPattern,  
  "Required pattern : AAA/ANNNNN/NNEE (A: Alphabet, N: Number, E: Optional) can be comma-delimited, no spaces"
);
  

export const DOCModelsSchema = Yup.object().shape({
  docId: Yup.number().integer().label('DOC Id'),
  docAttachmentId: Yup.number().integer().moreThan(0,'DOC required').required().label('DOC Attachment'),
  docAttachmentIdAttachmentName: Yup.string().trim(),
  siteApplicationId: Yup.number().integer().label('Site Application ID'),
  inspectionId: Yup.number().integer().label('Inspection ID'),
  companyName: Yup.string().trim().label('Company Name'),
  installer: Yup.string().trim().label('Installer Company'),
  projectName: Yup.string().trim().label('Project Name'),
  planNo: Yup.string().trim().label('Plan No'),
  productDescription: Yup.string().trim().label('Product Description'),
  cocNo: Yup.string().trim().label('COC Number'),
  brandModel: Yup.string().trim().label('Brand Model'),
  areaOfCoverage: Yup.number().label('Area of Coverage'),
  location: Yup.string().trim().label('Location'),
  unit: Yup.string().trim().label('Unit of Measure'),
  series: Yup.string().trim().label('Series'),
  no: Yup.number().integer().label('No'),
  revision: Yup.number().integer().label('Revision'),
  split: Yup.number().integer().label('Split'),
  getcbRef: Yup.number().integer().label('CB Reference'),                
});

export const ROIModelsSchema = Yup.object().shape({
  roiId: Yup.number().label('ROI ID'),
  roiAttachmentId: Yup.number().label('ROI Attachment ID'),
  inspectionId: Yup.number().label('Inspection ID'),
  siteApplicationId: Yup.number().label('Site Application ID'),
  cocHolderRef: Yup.string().trim().label('CoC Holder Ref'),
  cocHolder: Yup.string().trim().label('CoC Holder'),
  cocHolderAddress: Yup.string().trim().label('CoC Holder Address'),
  installerCompany: Yup.string().trim().label('Installer Company'),
  cocNo: Yup.string().trim().label('cocNo'),
  brand: Yup.string().trim().label('brand'),
  model: Yup.string().trim().label('Model'),
  country: Yup.string().trim().label('Country'),
  projectName: Yup.string().trim().label('Project Name'),
  planNo: Yup.string().trim().label('Plan No'),
  inspector: Yup.string().trim().label('Inspector'),
  series: Yup.string().trim().label('Series'),
  no: Yup.number().label('No'),
  quantity: Yup.string().trim().label('Quantity'),
  serial: Yup.string().trim().label('Serial'),
  revision: Yup.number().label('Revision'),
  split: Yup.number().label('Split'),
  roiDetails: Yup.array().label('ROI Details'),
  getcbRef: Yup.string().trim().label('CB Reference'),
});